export default "__VITE_ASSET__D_TKmX8Q__"